import apiService from './apiService';

/**
 * One-on-One Prep Email Service
 * 
 * Sends one-on-one preparation email via backend API
 */

/**
 * Send one-on-one prep email
 */
export async function sendOneOnOnePrepEmail(data: {
  recipientEmail: string;
  managerName: string;
  teamMemberName: string;
  prepContent: string;
  meetingDate?: string;
}): Promise<boolean> {
  try {
    const response = await apiService.post('/insights/one-on-one-prep/email', {
      recipientEmail: data.recipientEmail,
      recipientName: data.managerName,
      prepContent: data.prepContent,
      // dashboardUrl is optional and will use default from backend if not provided
    });

    // Return true if email was sent successfully
    return response?.success === true || response?.data?.success === true;
  } catch (error) {
    console.error('Failed to send one-on-one prep email:', error);
    return false;
  }
}
